var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error__text"},[_c('h1',{staticClass:"error__code"},[_vm._t("code")],2),_c('span',{staticClass:"error__descr"},[_vm._t("description")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }